import { render, staticRenderFns } from "./sso.vue?vue&type=template&id=a2ed017e&scoped=true"
import script from "./sso.vue?vue&type=script&lang=js"
export * from "./sso.vue?vue&type=script&lang=js"
import style0 from "./sso.vue?vue&type=style&index=0&id=a2ed017e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ed017e",
  null
  
)

export default component.exports